// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;900&family=Noto+Sans:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@100..700,0..1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-details-page {
  --course-type-heading: clamp(2.1rem, 2.4vw, 2.5rem);
  --course-type-card-heading: 1.25rem;
  --course-type-body: 1.0625rem;
  --course-type-body-lg: 1.125rem;
  --course-type-cta: 1rem;
  background: #ece4ed;
  min-height: 100vh;
  color: #0d121b;
  font-family: 'Noto Sans', 'Inter', sans-serif;
  padding: 6rem 1rem 4rem;
}

.course-details-wrapper {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.course-tab-selector {
  display: flex;
  gap: 0.75rem;
  border-radius: 15px;
  background: #d6c3d9;
  padding: 0.3rem;
  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.08);
  border: 2px solid #370b3b;
}

.course-tab {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.3rem 1rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  border-radius: 999px;
  color: #370b3b;
  transition: all 0.4s ease;
}

.course-tab--active {
  background: linear-gradient(135deg, #370b3b, #4a1548);
  color: white;
  box-shadow: 0 10px 30px rgba(55, 11, 59, 0.35);
}

.course-tab--link {
  background: #d6c3d9;
  color: #370b3b;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
}

/* ==============================
   HERO (JEE / NEET)
   ============================== */

.course-hero-card {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 1rem;
  padding: 0rem;
  border-radius: 22px;
  background: linear-gradient(135deg, #370b3b, #2a082d);
  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.25);
}

.hero-media {
  background-color: transparent;
  position: relative;
  flex: 0 0 48%;
  min-height: 360px;
  border-radius: 22px;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  box-shadow: 0 18px 44px rgba(13, 18, 27, 0.18);
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0));
  pointer-events: none;
  opacity: 0.35;
}

.hero-content {
  flex: 1;
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.9rem;
  color: #ffffff;
}

.hero-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #0f49bd;
  background: rgba(255, 255, 255, 0.92);
}

.course-hero-card h1 {
  margin: 0;
  font-family: 'Lexend', 'Noto Sans', sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(34px, 3.6vw, 56px);
  line-height: 1.05;
  color: #ffffff;
}

.course-hero-card p {
  margin: 0;
  max-width: 520px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 14.5px;
}

.course-hero-card .neet-samarpan-text {
  margin-top: 0.5rem;
  max-width: 720px;
  color: #f59e0b !important;
  font-size: 1.18rem;
  line-height: 1.5;
  font-weight: 600;
}

.course-hero-card .jee-sunischit-text {
  margin-top: 0.5rem;
  max-width: 720px;
  color: #f59e0b !important;
  font-size: 1.18rem;
  line-height: 1.5;
  font-weight: 600;
}

.course-hero-card .hero-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
  width: auto;
}

.course-hero-card .hero-cta {
  border: none;
  cursor: pointer;
  font-weight: 800;
  border-radius: 12px;
  padding: 12px 18px;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, filter 0.15s ease;
  box-shadow: none;
}

.course-hero-card .hero-cta:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(0.98);
}

.course-hero-card .hero-cta--primary {
  background: white;
  color: #370b3b;
  box-shadow: 0 16px 34px rgba(15, 73, 189, 0.26);
  border: 3px solid #370b3b;
}

.course-hero-card .hero-cta--primary:hover,
.course-hero-card .hero-cta--primary:focus,
.course-hero-card .hero-cta--primary:active {
  background: #ffffff;
  color: #f59e0b;
}

.course-hero-card .hero-cta--secondary {
  background: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.course-hero-card .hero-cta--secondary:hover,
.course-hero-card .hero-cta--secondary:focus,
.course-hero-card .hero-cta--secondary:active {
  background: transparent;
  color: #f59e0b;
}

/* JEE: image LEFT, content RIGHT */
.course-hero-card--jee {
  flex-direction: row-reverse;
}

.course-hero-card--jee .hero-media {
  background-position: left center;
  background-size: 75%;
}

.course-hero-card--jee .hero-media {
  /* background-size: 85%;
  width: 40%; */
  background-position: left center;
}

/* NEET: content LEFT, image RIGHT */
.course-hero-card--neet {
  flex-direction: row;
}

.course-hero-card--neet .hero-media {
  background-position: right center;
  background-size: 75%;

}

.course-hero-card--neet .hero-media {
  background-position: right center;
}

@media (max-width: 980px) {
  .course-hero-card {
    flex-direction: column;
    padding: 1rem;
  }

  .hero-media {
    flex: none;
    width: 100%;
    min-height: 300px;
    border-radius: 20px;
  }

  .hero-content {
    padding: 1.25rem 1rem 1.4rem;
    text-align: left;
  }

  .course-hero-card .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }
}

.course-highlights,
.course-curriculum,
.course-advantage {
  background: white;
  border-radius: 1.5rem;
  padding: 2.25rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}

.course-highlights h2,
.course-curriculum h2,
.course-advantage h2 {
  margin: 0 0 1rem;
  font-size: var(--course-type-heading);
  color: #370b3b;
}

.highlight-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;

}

.highlight-card {
  border: 2px solid #370b3b;
  border-radius: 1.25rem;
  padding: 1.25rem;
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background-color: #d6c3d9;
}

.highlight-card:hover {
  border-color: #A758AB;
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.12);
}

.highlight-icon {
  width: 60px;
  height: 60px;
  border-radius: 999px;
  background: transparent;
  color: #370b3b;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
}

.highlight-card h3 {
  margin: 0;
  font-size: var(--course-type-card-heading);
  font-weight: 600;
}

.highlight-card p {
  margin: 0.35rem 0 0;
  color: #370b3b;
  font-size: var(--course-type-body-lg);
  line-height: 1.55;
}

.section-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.brochure-link {
  font-weight: 600;
  color: #0f49bd;
  cursor: pointer;
}

.brochure-links {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.subtext {
  margin: 0 0 1rem;
  color: #4c669a;
}

.curriculum-panels {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.curriculum-panel {
  border: 2px solid #370b3b;
  border-radius: 0.85rem;
  padding: 0;
  background: #d6c3d9;
  overflow: hidden;
}

.curriculum-panel summary {
  cursor: pointer;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #0d121b;
  gap: 0.75rem;
}

.curriculum-panel summary span {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.curriculum-panel .expand-indicator {
  transition: transform 0.45s ease;
}

.curriculum-panel .expand-indicator.is-open {
  transform: rotate(180deg);
}

.panel-body {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0 1.5rem;
  color: #3f3434;
  font-size: var(--course-type-body);
  line-height: 1.5;
  font-weight: 500;
  transition: max-height 0.5s ease, opacity 0.4s ease, padding 0.5s ease;
}

.curriculum-panel[open] .panel-body {
  max-height: 460px;
  opacity: 1;
  padding: 0 1.5rem 1.25rem;
}

.panel-body ul {
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #370b3b;
}

.highlight-note {
  margin-top: 1.5rem;
  border-radius: 1rem;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  padding: 1rem 1.4rem;
  display: flex;
  gap: 0.65rem;
  align-items: center;
  color: #0f49bd;
}

.highlight-note span {
  font-size: 1.4rem;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem;
}

.advantage-card {
  border: 2px solid #370b3b;
  border-radius: 1rem;
  padding: 1.25rem;
  background: #d6c3d9;
  display: flex;
  gap: 0.9rem;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
}

.advantage-icon {
  width: 48px;
  height: 48px;
  border-radius: 1rem;
  background: transparent;
  color: #370b3b;
  display: grid;
  place-items: center;
  font-size: 1.6rem;
}

.advantage-card h3 {
  margin: 0;
  font-size: var(--course-type-card-heading);
}

.advantage-card p {
  margin: 0.35rem 0 0;
  color: #370b3b;
  font-size: var(--course-type-body);
  line-height: 1.55;
}

.course-cta {
  background: #370b3b;
  border-radius: 1.75rem;
  padding: clamp(1.75rem, 2.5vw, 2.5rem);
  color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.4);
}

.course-cta h2 {
  margin: 0;
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  color :white;
}

.course-cta p {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  max-width: 420px;
  font-size: 1.2rem;
}

.cta-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.course-cta .hero-cta,
.course-cta .hero-cta--primary,
.course-cta .hero-cta--secondary {
  background: #370b3b;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.32);
  font-size: var(--course-type-cta);
  box-shadow: none;
}

.course-cta .hero-cta:hover,
.course-cta .hero-cta--primary:hover,
.course-cta .hero-cta--secondary:hover {
  background: #4a1548;
  color: #f59e0b;
}

@media (max-width: 768px) {
  .course-tab-selector {
    flex-direction: column;
  }

  .course-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .hero-content {
    padding: 1.75rem;
  }

  .course-highlights,
  .course-curriculum,
  .course-advantage {
    padding: 1.75rem;
    
  }

  .course-cta {
    flex-direction: column;
    text-align: center;
  }
}

html[data-theme="dark"] .course-details-page {
  background: #030712;
  color: #f8fafc;
}

html[data-theme="dark"] .course-highlights,
html[data-theme="dark"] .course-curriculum,
html[data-theme="dark"] .course-advantage,
html[data-theme="dark"] .course-cta {
  background: #0a0f1c;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.45);
}

html[data-theme="dark"] .highlight-card,
html[data-theme="dark"] .advantage-card,
html[data-theme="dark"] .curriculum-panel {
  border-color: rgba(255, 255, 255, 0.06);
  background: #111827;
}

html[data-theme="dark"] .highlight-card p,
html[data-theme="dark"] .highlight-card h3,
html[data-theme="dark"] .advantage-card p,
html[data-theme="dark"] .advantage-card h3,
html[data-theme="dark"] .curriculum-panel summary,
html[data-theme="dark"] .curriculum-panel .panel-body,
html[data-theme="dark"] .course-cta p {
  color: #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Courses/course-details.css"],"names":[],"mappings":"AAGA;EACE,mDAAmD;EACnD,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;mCAEmC;;AAEnC;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4EAA4E;EAC5E,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;;EAGE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;eACa;EACb,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;;AAEtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;;EAGE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;;EAGE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;;AAEd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;;EAElB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;900&family=Noto+Sans:wght@400;500;600&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@100..700,0..1&display=swap');\r\n\r\n.course-details-page {\r\n  --course-type-heading: clamp(2.1rem, 2.4vw, 2.5rem);\r\n  --course-type-card-heading: 1.25rem;\r\n  --course-type-body: 1.0625rem;\r\n  --course-type-body-lg: 1.125rem;\r\n  --course-type-cta: 1rem;\r\n  background: #ece4ed;\r\n  min-height: 100vh;\r\n  color: #0d121b;\r\n  font-family: 'Noto Sans', 'Inter', sans-serif;\r\n  padding: 6rem 1rem 4rem;\r\n}\r\n\r\n.course-details-wrapper {\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2.5rem;\r\n}\r\n\r\n.course-tab-selector {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  border-radius: 15px;\r\n  background: #d6c3d9;\r\n  padding: 0.3rem;\r\n  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.08);\r\n  border: 2px solid #370b3b;\r\n}\r\n\r\n.course-tab {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0.3rem 1rem;\r\n  font-weight: 600;\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  border-radius: 999px;\r\n  color: #370b3b;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.course-tab--active {\r\n  background: linear-gradient(135deg, #370b3b, #4a1548);\r\n  color: white;\r\n  box-shadow: 0 10px 30px rgba(55, 11, 59, 0.35);\r\n}\r\n\r\n.course-tab--link {\r\n  background: #d6c3d9;\r\n  color: #370b3b;\r\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);\r\n}\r\n\r\n/* ==============================\r\n   HERO (JEE / NEET)\r\n   ============================== */\r\n\r\n.course-hero-card {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 1rem;\r\n  padding: 0rem;\r\n  border-radius: 22px;\r\n  background: linear-gradient(135deg, #370b3b, #2a082d);\r\n  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.25);\r\n}\r\n\r\n.hero-media {\r\n  background-color: transparent;\r\n  position: relative;\r\n  flex: 0 0 48%;\r\n  min-height: 360px;\r\n  border-radius: 22px;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  overflow: hidden;\r\n  box-shadow: 0 18px 44px rgba(13, 18, 27, 0.18);\r\n}\r\n\r\n.hero-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0));\r\n  pointer-events: none;\r\n  opacity: 0.35;\r\n}\r\n\r\n.hero-content {\r\n  flex: 1;\r\n  padding: 8px 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 0.9rem;\r\n  color: #ffffff;\r\n}\r\n\r\n.hero-badge {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  font-size: 0.9rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.09em;\r\n  text-transform: uppercase;\r\n  color: #0f49bd;\r\n  background: rgba(255, 255, 255, 0.92);\r\n}\r\n\r\n.course-hero-card h1 {\r\n  margin: 0;\r\n  font-family: 'Lexend', 'Noto Sans', sans-serif;\r\n  font-weight: 900;\r\n  letter-spacing: -0.02em;\r\n  font-size: clamp(34px, 3.6vw, 56px);\r\n  line-height: 1.05;\r\n  color: #ffffff;\r\n}\r\n\r\n.course-hero-card p {\r\n  margin: 0;\r\n  max-width: 520px;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  line-height: 1.6;\r\n  font-size: 14.5px;\r\n}\r\n\r\n.course-hero-card .neet-samarpan-text {\r\n  margin-top: 0.5rem;\r\n  max-width: 720px;\r\n  color: #f59e0b !important;\r\n  font-size: 1.18rem;\r\n  line-height: 1.5;\r\n  font-weight: 600;\r\n}\r\n\r\n.course-hero-card .jee-sunischit-text {\r\n  margin-top: 0.5rem;\r\n  max-width: 720px;\r\n  color: #f59e0b !important;\r\n  font-size: 1.18rem;\r\n  line-height: 1.5;\r\n  font-weight: 600;\r\n}\r\n\r\n.course-hero-card .hero-actions {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n  margin-top: 0.75rem;\r\n  width: auto;\r\n}\r\n\r\n.course-hero-card .hero-cta {\r\n  border: none;\r\n  cursor: pointer;\r\n  font-weight: 800;\r\n  border-radius: 12px;\r\n  padding: 12px 18px;\r\n  font-size: 14px;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n  box-shadow: none;\r\n}\r\n\r\n.course-hero-card .hero-cta:hover {\r\n  transform: translateY(-1px);\r\n  color: #f59e0b;\r\n  filter: brightness(0.98);\r\n}\r\n\r\n.course-hero-card .hero-cta--primary {\r\n  background: white;\r\n  color: #370b3b;\r\n  box-shadow: 0 16px 34px rgba(15, 73, 189, 0.26);\r\n  border: 3px solid #370b3b;\r\n}\r\n\r\n.course-hero-card .hero-cta--primary:hover,\r\n.course-hero-card .hero-cta--primary:focus,\r\n.course-hero-card .hero-cta--primary:active {\r\n  background: #ffffff;\r\n  color: #f59e0b;\r\n}\r\n\r\n.course-hero-card .hero-cta--secondary {\r\n  background: transparent;\r\n  color: #ffffff;\r\n  border: 1px solid rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.course-hero-card .hero-cta--secondary:hover,\r\n.course-hero-card .hero-cta--secondary:focus,\r\n.course-hero-card .hero-cta--secondary:active {\r\n  background: transparent;\r\n  color: #f59e0b;\r\n}\r\n\r\n/* JEE: image LEFT, content RIGHT */\r\n.course-hero-card--jee {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.course-hero-card--jee .hero-media {\r\n  background-position: left center;\r\n  background-size: 75%;\r\n}\r\n\r\n.course-hero-card--jee .hero-media {\r\n  /* background-size: 85%;\r\n  width: 40%; */\r\n  background-position: left center;\r\n}\r\n\r\n/* NEET: content LEFT, image RIGHT */\r\n.course-hero-card--neet {\r\n  flex-direction: row;\r\n}\r\n\r\n.course-hero-card--neet .hero-media {\r\n  background-position: right center;\r\n  background-size: 75%;\r\n\r\n}\r\n\r\n.course-hero-card--neet .hero-media {\r\n  background-position: right center;\r\n}\r\n\r\n@media (max-width: 980px) {\r\n  .course-hero-card {\r\n    flex-direction: column;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .hero-media {\r\n    flex: none;\r\n    width: 100%;\r\n    min-height: 300px;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .hero-content {\r\n    padding: 1.25rem 1rem 1.4rem;\r\n    text-align: left;\r\n  }\r\n\r\n  .course-hero-card .hero-actions {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n.course-highlights,\r\n.course-curriculum,\r\n.course-advantage {\r\n  background: white;\r\n  border-radius: 1.5rem;\r\n  padding: 2.25rem;\r\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.course-highlights h2,\r\n.course-curriculum h2,\r\n.course-advantage h2 {\r\n  margin: 0 0 1rem;\r\n  font-size: var(--course-type-heading);\r\n  color: #370b3b;\r\n}\r\n\r\n.highlight-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 1.25rem;\r\n\r\n}\r\n\r\n.highlight-card {\r\n  border: 2px solid #370b3b;\r\n  border-radius: 1.25rem;\r\n  padding: 1.25rem;\r\n  display: flex;\r\n  gap: 0.9rem;\r\n  align-items: flex-start;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n  background-color: #d6c3d9;\r\n}\r\n\r\n.highlight-card:hover {\r\n  border-color: #A758AB;\r\n  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.12);\r\n}\r\n\r\n.highlight-icon {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 999px;\r\n  background: transparent;\r\n  color: #370b3b;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.highlight-card h3 {\r\n  margin: 0;\r\n  font-size: var(--course-type-card-heading);\r\n  font-weight: 600;\r\n}\r\n\r\n.highlight-card p {\r\n  margin: 0.35rem 0 0;\r\n  color: #370b3b;\r\n  font-size: var(--course-type-body-lg);\r\n  line-height: 1.55;\r\n}\r\n\r\n.section-heading {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.brochure-link {\r\n  font-weight: 600;\r\n  color: #0f49bd;\r\n  cursor: pointer;\r\n}\r\n\r\n.brochure-links {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.subtext {\r\n  margin: 0 0 1rem;\r\n  color: #4c669a;\r\n}\r\n\r\n.curriculum-panels {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.curriculum-panel {\r\n  border: 2px solid #370b3b;\r\n  border-radius: 0.85rem;\r\n  padding: 0;\r\n  background: #d6c3d9;\r\n  overflow: hidden;\r\n}\r\n\r\n.curriculum-panel summary {\r\n  cursor: pointer;\r\n  padding: 1.25rem 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 600;\r\n  color: #0d121b;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.curriculum-panel summary span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n}\r\n\r\n.curriculum-panel .expand-indicator {\r\n  transition: transform 0.45s ease;\r\n}\r\n\r\n.curriculum-panel .expand-indicator.is-open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.panel-body {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  padding: 0 1.5rem;\r\n  color: #3f3434;\r\n  font-size: var(--course-type-body);\r\n  line-height: 1.5;\r\n  font-weight: 500;\r\n  transition: max-height 0.5s ease, opacity 0.4s ease, padding 0.5s ease;\r\n}\r\n\r\n.curriculum-panel[open] .panel-body {\r\n  max-height: 460px;\r\n  opacity: 1;\r\n  padding: 0 1.5rem 1.25rem;\r\n}\r\n\r\n.panel-body ul {\r\n  margin: 0.75rem 0 0;\r\n  padding-left: 1.25rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  color: #370b3b;\r\n}\r\n\r\n.highlight-note {\r\n  margin-top: 1.5rem;\r\n  border-radius: 1rem;\r\n  background: #eff6ff;\r\n  border: 1px solid #dbeafe;\r\n  padding: 1rem 1.4rem;\r\n  display: flex;\r\n  gap: 0.65rem;\r\n  align-items: center;\r\n  color: #0f49bd;\r\n}\r\n\r\n.highlight-note span {\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.advantage-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n  gap: 1.25rem;\r\n}\r\n\r\n.advantage-card {\r\n  border: 2px solid #370b3b;\r\n  border-radius: 1rem;\r\n  padding: 1.25rem;\r\n  background: #d6c3d9;\r\n  display: flex;\r\n  gap: 0.9rem;\r\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.advantage-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 1rem;\r\n  background: transparent;\r\n  color: #370b3b;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.advantage-card h3 {\r\n  margin: 0;\r\n  font-size: var(--course-type-card-heading);\r\n}\r\n\r\n.advantage-card p {\r\n  margin: 0.35rem 0 0;\r\n  color: #370b3b;\r\n  font-size: var(--course-type-body);\r\n  line-height: 1.55;\r\n}\r\n\r\n.course-cta {\r\n  background: #370b3b;\r\n  border-radius: 1.75rem;\r\n  padding: clamp(1.75rem, 2.5vw, 2.5rem);\r\n  color: white;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.4);\r\n}\r\n\r\n.course-cta h2 {\r\n  margin: 0;\r\n  font-size: clamp(1.8rem, 3vw, 2.4rem);\r\n  color :white;\r\n}\r\n\r\n.course-cta p {\r\n  margin: 0;\r\n  color: rgba(255, 255, 255, 0.85);\r\n  max-width: 420px;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.cta-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.course-cta .hero-cta,\r\n.course-cta .hero-cta--primary,\r\n.course-cta .hero-cta--secondary {\r\n  background: #370b3b;\r\n  color: #ffffff;\r\n  border: 1px solid rgba(255, 255, 255, 0.32);\r\n  font-size: var(--course-type-cta);\r\n  box-shadow: none;\r\n}\r\n\r\n.course-cta .hero-cta:hover,\r\n.course-cta .hero-cta--primary:hover,\r\n.course-cta .hero-cta--secondary:hover {\r\n  background: #4a1548;\r\n  color: #f59e0b;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .course-tab-selector {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .course-tab {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n\r\n  .hero-content {\r\n    padding: 1.75rem;\r\n  }\r\n\r\n  .course-highlights,\r\n  .course-curriculum,\r\n  .course-advantage {\r\n    padding: 1.75rem;\r\n    \r\n  }\r\n\r\n  .course-cta {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .course-details-page {\r\n  background: #030712;\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .course-highlights,\r\nhtml[data-theme=\"dark\"] .course-curriculum,\r\nhtml[data-theme=\"dark\"] .course-advantage,\r\nhtml[data-theme=\"dark\"] .course-cta {\r\n  background: #0a0f1c;\r\n  border-color: rgba(255, 255, 255, 0.08);\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .highlight-card,\r\nhtml[data-theme=\"dark\"] .advantage-card,\r\nhtml[data-theme=\"dark\"] .curriculum-panel {\r\n  border-color: rgba(255, 255, 255, 0.06);\r\n  background: #111827;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .highlight-card p,\r\nhtml[data-theme=\"dark\"] .highlight-card h3,\r\nhtml[data-theme=\"dark\"] .advantage-card p,\r\nhtml[data-theme=\"dark\"] .advantage-card h3,\r\nhtml[data-theme=\"dark\"] .curriculum-panel summary,\r\nhtml[data-theme=\"dark\"] .curriculum-panel .panel-body,\r\nhtml[data-theme=\"dark\"] .course-cta p {\r\n  color: #e5e7eb;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
